module.exports = __webpack_public_path__ + "static/media/Very happy Face.89c17a0c.svg";